import i18n from "i18n";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
const eventStatusLabel = (status) => SECURITY_EVENT_STATUSES[status] ? i18n.t(`event_statuses.${status.toLowerCase()}`, { ns: "enterprise_security_events" }) : String(status);
export default eventStatusLabel;
